import React, { useState, useEffect,useCallback } from "react";
import axios from "axios";

// Components
import Preloader from "../../../components/Preloader/Preloader";

import MUIDataTable from "mui-datatables";
import Autocomplete from "@material-ui/lab/Autocomplete";

//Date Range
import { addDays, format } from "date-fns";
import { DateRangePicker } from "materialui-daterange-picker";
import { debounce } from 'lodash';
import CircularProgress from '@material-ui/core/CircularProgress';

// Material UI Component
import {
	FormGroup,
	FormLabel,
	FormControl,
	// ListItemText,
	TextField,
	// Checkbox,
	// FormControlLabel,
	Grid,
    Select,
    Input,
	InputLabel,
	// MenuItem,
	Modal,
	Backdrop,
    Fade,
    Button,
    FormHelperText,
	NativeSelect,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
// Material Icons
import { AssessmentTwoTone } from "@material-ui/icons";
import { NavLink } from "react-router-dom";
//Material UI Icons
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import {get_cookies, isLoggedIn} from "../../../components/Cookies/Cookies";
import numeral from "numeral";

const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
}));

const InventoryEnding = () => {
    const [posts, setPosts] = useState([]);
	const [dataLoaded, setDataLoaded] = useState(false);
	const [open, setOpen] = useState(false);
	const [modalOpen, setModalOpen] = useState(false);
	const [downloadFlag, setDownloadFlag] = useState(false);
	const [dateRange, setDateRange] = useState({
		startDate: new Date(),
		endDate: new Date(),
	});
	const classes = useStyles();
	const [branchIdNo, setbranchidNo] = useState(get_cookies('branchidno'));

	const [locId, setlocId] = useState(''); //loc id for new loc dropdown
    const [loc, setLoc] = useState([]); //for new loc dropdown

    const [invId, setinvId] = useState(''); //inv id for new inv dropdown
    const [inv, setInv] = useState([]); //for new inv dropdown

    const [searchResults, setSearchResults] = useState([]);
	const [loading, setLoading] = useState(false); 


	useEffect(() => {
		data();
	}, []);
	
	const x = 0;
	useEffect(() => { //
		isLoggedIn();
	}, [x]);

	useEffect(() => {
		if(posts.length > 0){
			setDownloadFlag(true);
		}else{
			setDownloadFlag(false);
		}
	}, [posts]);
	
	//console.log('Base URL', process.env.REACT_APP_API_URL);

	//search button
	const dataFilter = async () => {
			setDataLoaded(false);
        	await axios.get(
				`${process.env.REACT_APP_API_URL}/get_inv_ending`, {
            params:{
                date_from: format(dateRange.startDate, "yyyy-MM-dd"), //format(dateRange.startDate, "yyyy/MM/dd/")
                date_to: format(dateRange.endDate, "yyyy-MM-dd"),   //format(dateRange.endDate, "yyyy/MM/dd/")
				location_id: locId, //location idory dropdown
				item_id: invId, //inventory id
                jc_user_id_no: branchIdNo,  //branchidNo
            }
        }).then(function (res) {
			setPosts(res.data.data);
		  }).catch(function (error) {	
			console.log(error);
		  });
		  setDataLoaded(true);
    }
    
    const data = async () => {
		//get data for location dropdown
		await axios.get(`${process.env.REACT_APP_API_URL}/get_warehouse_list`)
		.then(function (res) {
			const allLocation= {
				id: "All",
				description: "All Location",
			};
			  res.data.data.unshift(allLocation);
			setLoc(res.data.data);
		  }).catch(function (error) {	
			console.log(error);
		  });  
        
        //get data for inventory dropdown
	await axios.get(`${process.env.REACT_APP_API_URL}/get_items_for_dropdown`, {
		params: {branchIdNo}
	    })

		.then(function (res) {
			//adding an "All" to the dropdown
			const AllItems = {
				item_id: "All",
				itemname: "All Inventory",
			};
			  res.data.data.unshift(AllItems);
			setInv(res.data.data);
		  }).catch(function (error) {	
			console.log(error);
		  });  
		setDataLoaded(true);	
    };

    const toggle = () => setOpen(!open);

	const handleModalOpen = () => {
		setModalOpen(true);
	};

	const handleModalClose = () => {
		setModalOpen(false);
	};

	const dateRangeHandler = (range) => {
		setDateRange(range);
		setOpen(false);
	};
	const fetchItems = async (searchTerm) => {
		if (!searchTerm) return;
	      
		if (searchTerm === "All Inventory") {
		return;
		}
		setLoading(true);
		try {
			const response = await axios.get(`${process.env.REACT_APP_API_URL}/get_items_for_dropdown`, {
			    params: { searchTerm ,branchIdNo}
			});
			setSearchResults(response.data.data);
		    } catch (error) {
			console.error("Error fetching items:", error.message);
		    } finally {
			setLoading(false); 
		    }
	    };
	
	const selectLocationProps = {
		options: loc,
		getOptionLabel: (option) => option.description
    };
    

    	    // Use debounce to limit API calls
		const debouncedFetchItems = useCallback(debounce(fetchItems, 900), []);

		const handleInputChange = (event, value) => {
		if (value) debouncedFetchItems(value);  // Only call debouncedFetchItems if value is not empty
		else setSearchResults([]); 
	
		};
	    
	//     const selectInventoryProps = {
	// 	//options: dummy_item_array,
	// 	options: searchResults.length>0? searchResults:inv, //pass the items array as props from PurchaseOrderInformation
	// 	getOptionLabel: (option) => option.itemname || '',
	// 	loading,  
	//     };
	const selectInventoryProps = {
                options: inv,
                getOptionLabel: (option) => option.itemname
            };
	    const modifiedOptions = [
		{ itemname: "All Inventory", id: "All" }, // Prepend custom option
		...selectInventoryProps.options,
	      ];
    
    const columns = [
            {
                name: "no",
                label: "No.",
                options: {
                },
            },
            {
                name: "description",
                label: "Description",
                options: {
                },
            },
            {
                name: "unit",
                label: "Unit",
                options: {
                },
            },
			{
                name: "total",
                label: "Total",
					options: {
    					customBodyRender: (value, tableMeta, updateValue) => {
    					    return (
    					            <div style={{textAlign:"right"}}>{numeral(value).format('0,0.00')}</div>
    					    );
    					  }
    					},
            	},
			{
                name: "location",
                label: "Location",
                options: {
                },
            },
        ];

        const options = {
            filter: true,
            selectableRows: "none",
            filterType: "multiselect",
            responsive: "standard",
            setFilterChipProps: (colIndex, colName, data) => {
                console.log(colIndex, colName, data);
                return {
                    color: "primary",
                    variant: "outlined",
                    className: "testClass123",
                };
            },
			download: downloadFlag,  //add this
			print: downloadFlag, //add this
			downloadOptions: {
				filename : 'InventoryEnding.csv' //change filename of csv
			}
            // tableBodyHeight,
		};
		
		const style = {
            marginBottom: '1rem',
        };

        return (
            		<div className="page">
            			<div className="page-header">
            				<div className="page-icon">
            					<AssessmentTwoTone />
            				</div>
            				<NavLink to={"/reports"}><h4 style={{color:"#339933"}}>Reports</h4></NavLink>
							<ArrowForwardIosIcon  fontSize="small" color="disabled"/>
            				<h4 className="header-title">Inventory Ending Report</h4>
            			</div>
						<div className="page-container">
						
							<div style={style}>
								<Grid container spacing={1}>
								<Grid item xs={12} md={4} lg={3} xl={3}>
										<TextField
											id="outlined-basic"
											label="Select Date"
											variant="outlined"
											onFocus={() => setOpen(true)}
											autoComplete="off"
											value={`${format(
												dateRange.startDate,
												"MM/dd/yyyy"
											)} - ${format(dateRange.endDate, "MM/dd/yyyy")}`}
										/>
										<DateRangePicker
											open={open}
											toggle={toggle}
											onChange={(range) => dateRangeHandler(range)}
										/> 
									</Grid>

									<Grid item xs={12} md={12} lg={4}>
                                        <Autocomplete
                                            {...selectLocationProps}
                                            autoComplete
                                            includeInputInList
                                            className={classes.autoComplete}
                                            style ={{marginTop: "-15px"}}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    margin="normal"
                                                    label="Select Location"
                                                    variant="outlined"
                                                    required="true"
                                                />
                                            )}
                                            onChange={(event, newValue) => {
                                                if (!newValue == "" || !newValue == null){
                                                    console.log(newValue.id);
                                                    setlocId(newValue.id);
                                                }
                                            }}
                                        />     
									</Grid>

									<Grid item xs={12} md={12} lg={4}>
										<Autocomplete
											{...selectInventoryProps}
											autoComplete
											// options={modifiedOptions}
											includeInputInList
											className={classes.autoComplete}
											// onInputChange={handleInputChange}
											style ={{marginTop: "-15px"}}
											getOptionLabel={(option) => option.itemname || ""}
											renderInput={(params) => (
												<TextField
												    {...params}
												label="Select Inventory"
												    margin="normal"
												    variant="outlined"
												    InputProps={{
												    ...params.InputProps,
												//     endAdornment: (
												// 	<>
												// 	{loading ? <CircularProgress color="inherit" size={20} /> : null}
												// 	{params.InputProps.endAdornment}
												// 	</>
												//     ),
												    }}
												/>
												)}
												noOptionsText={loading ? "Searching..." : "No options"}
											onChange={(event, newValue) => {
												if (!newValue == "" || !newValue == null){
													console.log(newValue.item_id);
													setinvId(newValue.item_id);
												}
											}}
										/>     
									</Grid>
									{/* <Grid item xs={2} style={{marginBlock: "auto"}}>
										<Input placeholder="Branch ID No" inputProps={{ 'aria-label': 'description' }} onChange={e => setbranchidNo(e.target.value)}/>
									</Grid> */}
									<Grid item xs={1}  style={{"marginTop":"20px"}}>
										<Button variant="contained" color="primary"  onClick={() => {dataFilter()}}>Search</Button>
									</Grid>
								</Grid>        
							</div>
							
            				{!dataLoaded ? (
            					<Preloader />
            				) : (
            					<MUIDataTable
            						title={
            							<div>
            						
            								<div className="table-title">
            									Inventory Ending Report
            								</div>
            							</div>
            						}
            						data={posts}
            						columns={columns}
            						options={options}
            					/>
            				)}
            			</div>
            		</div>
            	);
};

export default InventoryEnding;